/**
 * Presentational: "Add New Facility" button with icon.
 * Single Responsibility: render button; parent supplies onClick (Interface Segregation).
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Plus } from 'lucide-react';
import { PAGE_COPY } from '../constants';

const BUTTON_CLASS =
  'group bg-gradient-to-br from-[#f8fbfd] to-white border-2 border-[#61b8e7]/30 rounded-[12px] h-[90px] flex items-center justify-center gap-3 hover:border-[#61b8e7] hover:shadow-md hover:shadow-[#61b8e7]/10 transition-all w-full';
const ICON_WRAPPER_CLASS =
  'bg-[#61b8e7] rounded-[6px] w-[32px] h-[32px] flex items-center justify-center group-hover:scale-110 transition-transform';
const LABEL_CLASS =
  'font-[\'Roboto:Medium\',sans-serif] font-medium text-[15px] text-[#61b8e7] group-hover:text-[#4da3d1]';
const LABEL_STYLE = { fontVariationSettings: "'wdth' 100" };

export function AddFacilityButton({ onClick, label = PAGE_COPY.ADD_FACILITY }) {
  return (
    <button type="button" onClick={onClick} className={BUTTON_CLASS}>
      <div className={ICON_WRAPPER_CLASS}>
        <Plus className="w-[18px] h-[18px] text-white" strokeWidth={3} />
      </div>
      <span className={LABEL_CLASS} style={LABEL_STYLE}>
        {label}
      </span>
    </button>
  );
}

AddFacilityButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  /** Button label (defaults to PAGE_COPY.ADD_FACILITY) */
  label: PropTypes.string,
};
